import React, { useEffect, useState } from "react";
import axiosInstance from "../api/axiosInstance";
import "./AdminLoginModal.scss";
import ArrowDropDownOutlinedIcon from "@mui/icons-material/ArrowDropDownOutlined";
import SvgIcon from "@mui/material/SvgIcon";
import Input from "./Input";

interface AdminCompanyProps {
    show?: boolean;
    loginId: string;
    onCallback?: (props: any) => void;
}

const AdminCompanyModal: React.FC<AdminCompanyProps> = ({
    show,
    loginId,
    onCallback,
}) => {
    const [companyList, setComapnyList] = useState<any[]>([]);
    const [companyShow, setCompanyShow] = useState<boolean>(false);
    const getCompanyList = async () => {
        await axiosInstance()
            .post(`/kiosk/selKioskCompanyList.do`, {})
            .then((res) => {
                setComapnyList(res.data.list);
            });
    };

    useEffect(() => {
        if (show) getCompanyList();
    }, [show]);
    return (
        <>
            <div className="modal-overlay">
                <div className="admin-modal-container">
                    <div className="modal-header">
                        {/* <button className="modal-close" onClick={onClose}>
            Close
          </button> */}
                    </div>
                    <div className="modal-content">
                        <h2 style={{ textAlign: "center" }}>업체 로그인 ID를 입력해주세요.</h2>
                    </div>
                    <div style={{ padding: "30px" }}>
                        <div
                            className="admin-login-id"
                            style={{ width: "auto", marginRight: "0" }}
                            onClick={() => {
                                setCompanyShow(!companyShow);
                            }}
                        >
                            <Input type={""} value={loginId}></Input>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AdminCompanyModal;
